import { createGenerator } from '@unocss/core';
import presetWind3 from '@unocss/preset-wind3';
import presetRemToPx from '@unocss/preset-rem-to-px';
import presetAttributify from '@unocss/preset-attributify';
import constants from '../constants';
import { getRules } from '../helpers/rules';
import { set } from '../helpers/generator';
import hooks from '../../hooks';

const createCSSGenerator = async () => {
  hooks.handlers.onBeforeCSSGeneratorInit();
  const generator = createGenerator({
    presets: [
      presetWind3(),
      presetAttributify(),
      presetRemToPx(),
      {
        name: 'yola-preset',
        rules: getRules(),
      },
    ],
    theme: {
      breakpoints: constants.breakpoints,
    },
  });

  set(generator);
};

export default createCSSGenerator;
